export default "__VITE_ASSET__CspDjxa6__"